import { Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CampaignManagerItemOfferModel,
  CampaignV2OffersQuery,
  CampaignV2OffersService,
  DATE_OPTIONS,
  DateOptions,
} from '@fgb/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-campaign-v2-details-offer-page',
  templateUrl: './campaign-v2-details-offer-page.component.html',
  styleUrls: ['./campaign-v2-details-offer-page.component.scss'],
})
export class CampaignV2DetailsOfferPageComponent implements OnInit, OnDestroy {
  currentCampaign: CampaignManagerItemOfferModel | any;
  campaignOfferSub: Subscription;
  isDateExpired: boolean = false;
  screenSize = ScreenType;

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private route: ActivatedRoute,
    private campaignV2OffersService: CampaignV2OffersService,
    private campaignV2OffersQuery: CampaignV2OffersQuery,
    private location: Location
  ) {}

  ngOnInit() {
    let offerId = +(this.route.snapshot.paramMap.get('offerId') || '0');
    this._updateOffer(offerId);
  }

  ngOnDestroy(): void {
    this.campaignOfferSub.unsubscribe();
  }

  _updateOffer(offerId: number) {
    if (!!offerId) {
      firstValueFrom(this.campaignV2OffersService.fetchV2Offers()).then(() => {
        this.campaignOfferSub = this.campaignV2OffersQuery.selectFirst().subscribe((campaignOffer) => {
          if (campaignOffer) {
            for (let entitlement of campaignOffer?.Offers) {
              if (entitlement.CampaignId === offerId) {
                this.currentCampaign = entitlement;
                if (new Date(this.currentCampaign.ExpiryDate) >= new Date()) {
                  this.isDateExpired = false;
                } else {
                  this.isDateExpired = true;
                }
                break;
              }
            }
          }
        });
      });
    }
  }

  goBack() {
    this.location.back();
  }
}
